import { useMutation, useQueryClient } from '@tanstack/react-query';
import { taskResponsibilitiesAPI } from '../api/task-responsibilities.api';
import type { CreateResponsibilityDto, UpdateResponsibilityDto } from '../types';

export const useCreateResponsibility = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateResponsibilityDto) => taskResponsibilitiesAPI.createResponsibility(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['task-responsibilities'] });
    },
  });
};

export const useUpdateResponsibility = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateResponsibilityDto }) =>
      taskResponsibilitiesAPI.updateResponsibility(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['task-responsibilities'] });
    },
  });
};

export const useDeleteResponsibility = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (responsibilityId: string) => taskResponsibilitiesAPI.deleteResponsibility(responsibilityId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['task-responsibilities'] });
    },
  });
};

export const useBulkUpdateResponsibilities = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      taskType,
      responsibilities
    }: {
      taskType: string;
      responsibilities: Array<{
        userId: string;
        daysPerWeek: number;
        isActive: boolean;
      }>;
    }) => taskResponsibilitiesAPI.bulkUpdateResponsibilities(taskType, responsibilities),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['task-responsibilities'] });
      queryClient.invalidateQueries({ queryKey: ['workload-statistics'] });
    },
  });
};
